import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText'
})
export class TruncateTextPipe implements PipeTransform {

  transform(value: string, maxLength: number = 50): string {
    if (!value) return '';
    return value.length > maxLength ? value.substr(0, maxLength) + '...' : value;
  }

}
